<div *ngIf="tenantList?.length > 1; else loader" class="login-main-container">
  <div class="login-side-logo" *ngIf="!isTabView">
    <img appPrependUrl src="/assets/images/transparent-home-login.png" alt="MyGooru Logo" class="mylogo" />
  </div>
  <div class="tenant-list-container">
    <header class="header-wrapper">
      <div class="toolbar">
        <div class="row align-items-center">
          <div (click)="goBack()">
            <img class="back-button" appPrependUrl src="/assets/icons/arrow-back.svg" alt="arrow-back" />
          </div>
          <div class="title-container">
            <div class="title-contain">
              <span class="sign-in-title-text">You have accounts in the following organizations/tenancies.</span>
            </div>
            <div>
              <span class="continue-to-text">Choose the one that you want to access.</span>
            </div>
          </div>
        </div>
      </div>
    </header>
    <main class="content">
      <ng-container *ngFor="let tenant of tenantList">
        <div class="tenant-container" (click)="doTenantLogin(tenant)">
          <div>
            <div class="tenant-img">
              <ng-container *ngIf="tenant.image_url; else showAvatar">
                <img [src]="tenant.image_url" />
              </ng-container>
              <ng-template #showAvatar>
                <div class="avatar">{{ getInitials(tenant?.tenant_name) }}</div>
              </ng-template>
            </div>
          </div>
          <div>
            <label class="tenant-name">{{ tenant?.tenant_name }}</label>
          </div>
        </div>
      </ng-container>
    </main>
  </div>
</div>
<ng-template #loader>
  <div class="ai-landing-page">
    <ai-landing-page></ai-landing-page>
  </div>
</ng-template>